/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ShiftSegmentComponent } from './shift-segment.component';
import { DxButtonModule } from 'devextreme-angular';

@NgModule({
  declarations: [ShiftSegmentComponent],
  imports: [CommonModule, DxButtonModule],
  exports: [ShiftSegmentComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ShiftSegmentModule {}
